import React from 'react';
import { Button } from '@mui/material';
import { useAtom, useSetAtom } from 'jotai';
import {
  pageAtom,
  isBackdropOpenAtom,
  snackbarPropsAtom,
} from '../../../atoms';
import {
  reActivationMailAtom,
  resetPasswordMailAtom,
} from '../../../atoms/emailAtoms';
import { PAGE } from '../../../constant/page';
import { ApiAccountsResendActivation } from '../../../api/apiAccountsResendActivation';
import { ApiAccountsResetPassword } from '../../../api/apiAccountsResetPassword';

const SendButton = (props: { email: string; isEmailValid: boolean }) => {
  const { email, isEmailValid } = props;
  const setIsBackdropOpen = useSetAtom(isBackdropOpenAtom);
  const [page, setPage] = useAtom(pageAtom);
  const setReActivationMail = useSetAtom(reActivationMailAtom);
  const setResetPasswordMail = useSetAtom(resetPasswordMailAtom);
  const setSnackbarProps = useSetAtom(snackbarPropsAtom);

  const onClickActivation = async () => {
    setIsBackdropOpen(true);
    await ApiAccountsResendActivation.post(email)
      .then(() => {
        setReActivationMail(email);
        setPage(PAGE.REACTIVATION_MAIL);
      })
      .catch((error) => {
        console.log(error);
        setSnackbarProps({
          isOpen: true,
          message: 'メールの送信に失敗しました。',
          type: 'error',
        });
      })
      .finally(() => {
        setIsBackdropOpen(false);
      });
  };

  const onClickResetPassword = async () => {
    setIsBackdropOpen(true);
    await ApiAccountsResetPassword.post(email)
      .then(() => {
        setResetPasswordMail(email);
        setPage(PAGE.CHANGE_PASSWORD_MAIL);
      })
      .catch((error) => {
        console.log(error);
        setSnackbarProps({
          isOpen: true,
          message: 'メールの送信に失敗しました。',
          type: 'error',
        });
      })
      .finally(() => {
        setIsBackdropOpen(false);
      });
  };

  return (
    <Button
      variant='contained'
      sx={{ width: '150px' }}
      disabled={!(email && isEmailValid)}
      color='primary'
      onClick={
        page === PAGE.REACTIVATION ? onClickActivation : onClickResetPassword
      }
    >
      送信
    </Button>
  );
};

export default React.memo(SendButton);
